import { Leaf, Grid3X3, BrickWall, Building2, Footprints, Shovel } from "lucide-react";

export const CONTACT = {
  name: "CWood Construction",
  phoneDisplay: "07494 873946",
  phoneWa: "447494873946",
  phoneTel: "+447494873946",
  email: "cwoodconstruction1@outlook.com",
  facebook: "CWoodConstruction",
  facebookUrl: "https://www.facebook.com/people/CWoodConstruction/61590528373500/",
  location: "Huddersfield, West Yorkshire",
  logo: "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/zmbpee9r_logo.jpeg",
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/l7yyuiej_p5.jpg",
  about: "https://customer-assets.emergentagent.com/job_d05769e1-a9f8-4ac9-a1d1-b3b773c8c11b/artifacts/nrsfrfh4_WhatsApp%20Image%202026-06-22%20at%2015.12.13.jpeg",
};

export const SERVICES = [
  {
    icon: Leaf,
    title: "Garden Transformations",
    description: "Complete redesigns and renovations of outdoor spaces, tailored to how you live.",
  },
  {
    icon: Grid3X3,
    title: "Patios & Paving",
    description: "Premium porcelain and natural stone patios installed to the highest standards.",
  },
  {
    icon: BrickWall,
    title: "Brickwork & Garden Walls",
    description: "Decorative and structural brickwork, boundary walls and retaining walls.",
  },
  {
    icon: Footprints,
    title: "Steps & Pathways",
    description: "Custom-built steps, pathways and access solutions that flow naturally.",
  },
  {
    icon: Shovel,
    title: "Landscaping",
    description: "Hard landscaping solutions to enhance and maximise outdoor living areas.",
  },
  {
    icon: Building2,
    title: "General Construction",
    description: "Professional building and home improvement services done properly.",
  },
];

export const WHY_CHOOSE = [
  "Fully Qualified Team",
  "Free No-Obligation Quotes",
  "Reliable & Professional Service",
  "High Quality Workmanship",
  "Local West Yorkshire Specialists",
  "Competitive Pricing",
];

export const PROJECTS = [
  {
    title: "Mirfield Garden Transformation",
    description:
      "Complete front garden renovation — new brick boundary wall, hardwood gate, fresh lawn and a porcelain & decking patio area.",
    image:
      "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/l7yyuiej_p5.jpg",
  },
  {
    title: "Indian Sandstone Patio",
    description:
      "Premium riven Indian sandstone patio laid in a mixed-tone blend, with crisp jointing and a smart step detail.",
    image:
      "https://customer-assets.emergentagent.com/job_d05769e1-a9f8-4ac9-a1d1-b3b773c8c11b/artifacts/xcgvhj9w_WhatsApp%20Image%202026-06-22%20at%2015.12.12%20%288%29.jpeg",
  },
  {
    title: "Garden & Lawn Transformation",
    description:
      "Full rear garden redesign — sandstone patio surround framing a fresh central lawn for a low-maintenance outdoor space.",
    image:
      "https://customer-assets.emergentagent.com/job_d05769e1-a9f8-4ac9-a1d1-b3b773c8c11b/artifacts/agnfyns3_WhatsApp%20Image%202026-06-22%20at%2015.12.12.jpeg",
  },
  {
    title: "Brick Boundary Wall",
    description:
      "Solid red-brick boundary wall with a neat coping finish — built to last and to lift the look of the property.",
    image: "/projects/brick-boundary-wall.jpg",
  },
  {
    title: "Single-Storey Extension",
    description:
      "Structural extension build — blockwork, dwarf walls and aluminium bi-fold doors creating a bright new living space.",
    image: "/projects/single-storey-extension.jpg",
  },
  {
    title: "Brickwork & Garden Walls",
    description:
      "Quality brickwork and garden walling, tied in cleanly alongside a new extension and existing stonework.",
    image: "/projects/brickwork-garden-walls.jpg",
  },
];

export const MIRFIELD = {
  title: "Mirfield Garden Transformation",
  subtitle: "Robin Royd Croft, Mirfield",
  blurb:
    "A full front garden transformation — from a cleared, muddy plot to a striking new outdoor space with a curved brick boundary wall, hardwood gate, laid lawn and a smart decked patio. Drag the slider to see the difference.",
  before:
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/ahtk6job_p3.jpg",
  after:
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/l7yyuiej_p5.jpg",
  gallery: [
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/0y8ghy5l_p1.jpg",
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/06eknn4s_p2.jpg",
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/x8kjbsx5_p4.jpg",
    "https://customer-assets.emergentagent.com/job_cwood-construction/artifacts/l7yyuiej_p5.jpg",
  ],
};

export const SHOWCASES = [
  {
    eyebrow: "Latest Transformation",
    title: MIRFIELD.title,
    subtitle: MIRFIELD.subtitle,
    blurb: MIRFIELD.blurb,
    before: MIRFIELD.before,
    after: MIRFIELD.after,
    gallery: MIRFIELD.gallery,
    cta: "Get a transformation like this",
    altLabel: "Mirfield garden",
  },
  {
    eyebrow: "Before & After",
    title: "Front Porch Build",
    subtitle: "New entrance porch & canopy",
    blurb:
      "A tired, weather-worn entrance completely rebuilt — fresh concrete base, timber-clad porch, pitched tiled roof and a smart new composite door. A warm, weatherproof welcome that transforms the front of the home.",
    before:
      "https://customer-assets.emergentagent.com/job_d05769e1-a9f8-4ac9-a1d1-b3b773c8c11b/artifacts/13379cvg_WhatsApp%20Image%202026-06-22%20at%2016.29.01.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_d05769e1-a9f8-4ac9-a1d1-b3b773c8c11b/artifacts/pzbffqxq_WhatsApp%20Image%202026-06-22%20at%2016.29.02.jpeg",
    gallery: [],
    cta: "Start your porch project",
    altLabel: "Front porch",
    aspect: "aspect-[3/4] sm:aspect-[4/5]",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "CWood Construction completely transformed our garden. Professional from start to finish and the quality of work was outstanding.",
    name: "Sarah M.",
    place: "Mirfield",
  },
  {
    quote:
      "Excellent communication and workmanship. Would highly recommend to anyone looking for a reliable builder.",
    name: "James T.",
    place: "Huddersfield",
  },
  {
    quote:
      "Fantastic patio installation. Very reliable and finished to a high standard. Couldn't be happier.",
    name: "Lisa H.",
    place: "Hartshead",
  },
];

export const SERVICE_OPTIONS = [
  "Garden Transformation",
  "Patios & Paving",
  "Brickwork & Garden Walls",
  "Steps & Pathways",
  "Landscaping",
  "General Construction",
  "Other / Not Sure",
];
